import {
  Button,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  ModalHeader,
  Stack,
  Text
} from '@homebotapp/hb-react-component-catalog'
import { FoundPreferredAgentCard } from '../../../homeowners/Valuation/TuneValueForm/HbnCmaFlow/FoundPreferredAgentCard'
import { CustomerProfileResponse } from './AddPreferredAgentModal'
import { defineMessages, useIntl } from 'react-intl'

export const MSG = defineMessages({
  bodyFoundAgent: {
    id: 'ExistingAgentCard.bodyFoundAgent',
    defaultMessage: 'We found this agent in the Homebot Network.'
  },
  bodyAddAgent: {
    id: 'Would you like to add them?',
    defaultMessage: 'Adding a real estate agent lets you reach them directly while exploring Homebot.'
  },
  heading: {
    id: 'ExistingAgentCard.heading',
    defaultMessage: 'Add real estate agent'
  },
  cancel: {
    id: 'ExistingAgentCard.cancel',
    defaultMessage: 'No, cancel'
  },
  add: {
    id: 'ExistingAgentCard.add',
    defaultMessage: 'Yes, add existing'
  }
})

interface ExistingAgentViewProps {
  agent: CustomerProfileResponse
  isSubmitting: boolean
  onConfirm: () => Promise<void>
  onClose: () => void
}

export const ExistingAgentCard = ({ agent, isSubmitting, onConfirm, onClose }: ExistingAgentViewProps) => {
  const intl = useIntl()
  return (
    <>
      <ModalHeader>
        <Text size='lg' fontWeight='semibold' color='neutral.900'>
          {intl.formatMessage(MSG.heading)}
        </Text>
      </ModalHeader>
      <ModalCloseButton onClick={onClose} />

      <ModalBody pb={6}>
        <Text color='neutral.700' mb={4}>
          {intl.formatMessage(MSG.bodyFoundAgent)}
        </Text>
        <Text size='lg' fontWeight='semibold' color='neutral.900' mb={4}>
          {intl.formatMessage(MSG.bodyAddAgent)}
        </Text>
        <FoundPreferredAgentCard agent={agent} corporateProfile={agent.corporateProfile} />
      </ModalBody>

      <ModalFooter>
        <Stack direction='row' gap={2} justifyContent='flex-end'>
          <Button
            variant='ghost'
            onClick={onClose}
            tracking={{
              guid: 'r3MWAnn3B4itMFMh8RUzq6',
              ui_context: 'Existing agent card cancel',
              descriptor: 'Cancel add existing agent to team'
            }}
          >
            {intl.formatMessage(MSG.cancel)}
          </Button>
          <Button
            colorScheme='primary'
            onClick={onConfirm}
            isLoading={isSubmitting}
            tracking={{
              guid: 'w2KXKtnnhbBPqQMp1nRtVm',
              ui_context: 'Existing agent card confirm',
              descriptor: 'Add existing agent to team'
            }}
          >
            {intl.formatMessage(MSG.add)}
          </Button>
        </Stack>
      </ModalFooter>
    </>
  )
}
